// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from 'axios';
import VDistpicker from 'v-distpicker' // 引入省市选择器
import VueAreaLinkage from 'vue-area-linkage' // 引入省市选择器
import SocialSharing from 'vue-social-sharing'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import VueCookies from 'cookies'

Vue.use(Element);
Vue.prototype.$message=Element.Message
Vue.prototype.$msgbox=Element.MessageBox
// Vue.prototype.$dialog=Element.Dialog
import $ from 'jquery'
import store from './store/index'
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper)



Vue.use(VueAreaLinkage);
Vue.use(SocialSharing);

Vue.component('v-distpicker', VDistpicker) // 注册组件
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$axios = axios;

import router from './router'

Vue.config.productionTip = false;
window.addEventListener('popstate',function(){
  location.reload()
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js